import styles from '../styles/loader.module.scss';

export const CircularLoader = () => {
  return (
    <div className={styles["loading-container"]} data-testid="circular-loader">
      <div className={styles["spinner"]}></div>
    </div>
  )
}
